import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthHeaders = () => {
  const lang = localStorage.getItem("lang") || "en";

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Accept-Language": lang,
  };
};

// Create tax
export const createTax = async (taxData) => {
  try {
    const response = await api.post(`${API_BASE_URL}api/taxes/create`, taxData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Create Tax API Error:", error);
    throw error.response?.data || { message: "Failed to create tax" };
  }
};

// Get all taxes
export const getAllTaxes = async (params = {}) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/taxes/list`, {
      headers: getAuthHeaders(),
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Get Taxes API Error:", error);
    throw error.response?.data || { message: "Failed to fetch taxes" };
  }
};

// Get tax detail
export const getTaxById = async (id) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/taxes/detail/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Get Tax Detail API Error:", error);
    throw error.response?.data || { message: "Failed to fetch tax detail" };
  }
};

// Update tax
export const updateTax = async (id, taxData) => {
  try {
    const response = await api.put(
      `${API_BASE_URL}api/taxes/update/${id}`,
      taxData,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Update Tax API Error:", error);
    throw error.response?.data || { message: "Failed to update tax" };
  }
};

// Delete tax
export const deleteTax = async (id) => {
  try {
    const response = await api.delete(`${API_BASE_URL}api/taxes/delete/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Delete Tax API Error:", error);
    throw error.response?.data || { message: "Failed to delete tax" };
  }
};